import { IconBoltFilled, IconSparkles } from "@tabler/icons-react"
import tjt from "../../assets/images/partner/tjt.png"
import olo from "../../assets/images/partner/olo.png"
import R365 from "../../assets/images/partner/r365.png"
import lunchbox from "../../assets/images/partner/lunchbox.png"
import crumbs from "../../assets/images/partner/crumbs.png"
import chatmeter from "../../assets/images/partner/chatmeter.png"
import Bilal_img from "../../assets/images/partner/Bilal_image.webp"
import { Link } from "react-router-dom"
import { motion } from 'framer-motion'
import { item } from "../homepage/Section1"
// import Marquee from "react-fast-marquee"
// import { useEffect, useState } from "react"

const Section1 = () => {
  //  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  // useEffect(() => {
  //   const handleResize = () => setIsMobile(window.innerWidth < 768);
  //   window.addEventListener("resize", handleResize);
  //   return () => window.removeEventListener("resize", handleResize);
  // }, []);
  return (
    <>
    <div className="s1-partner m-auto">
        <div className="bg-grid text-center">
            <div className="c1"></div>
            <div className="c2"></div>
            <div className="row">
                <div className="col-2 logo-left">
                    {/* <Link to={'https://tjtpa.com/'} target="_blank"><img src={tjt} className="tjt-logo animate__animated animate__backInLeft" alt="tjt brand logo" /></Link><br/> */}
                    <Link to={'https://www.olo.com/'} target="_blank"><img src={olo} className="olo-logo animate__animated animate__backInLeft" alt="olo brand logo" /></Link><br/>
                    <Link to={'https://www.linkedin.com/posts/realbilal_voosh-restaurant365-restaurants-activity-7312843244994711554-huZ3?utm_source=share&utm_medium=member_desktop&rcm=ACoAADCOKSsBBJ2dir3FrqipwcYXhTqxauSNJzQ'} target="_blank"><img src={R365} className="r365-logo animate__animated animate__backInLeft" alt="R365 brand logo" /></Link>
                </div>
                <motion.div whileInView="visible" initial="hidden" className="col-lg-8 col-sm-12">
                    <motion.div variants={item} whileInView="visible" initial="hidden" className="top-text">
                        <p><IconSparkles className="color-brand animate__animated animate__bounceIn animate__infinite animate__slower" /> #1 AI Restaurant Operations Automation Platform</p>
                    </motion.div>
                    <motion.div variants={item} whileInView="visible" initial="hidden" className="s1-head-text">
                        <h1>Join the <span>Voosh</span> partner network!</h1>
                        <p>Voosh makes delivery profitability effortless. Partners plug in with zero dev lift, generate new revenue streams, and deliver real ROI to every client.</p>
                    </motion.div>
                    <motion.div variants={item} whileInView="visible" initial="hidden" className="d-flex gap-3 justify-content-center s1-btn-grp">
                        <a href="#becomeAPartner"><div className="btn btn-dark rounded-pill shadow p-3 fw-bold bcm_partner_btn"><IconBoltFilled  className="color-brand" /> <ShinyText text="Apply to Become a Partner" disabled={false} speed={3} className='custom-class' /></div></a>
                        <Link to={'https://meetings.hubspot.com/bilal-k-s/meeting-with-bilal'}><div className="btn btn-outline-secondary rounded-pill shadow py-2 pe-3 fw-bold bilal_profile"><img className="rounded-pill" src={Bilal_img} alt="Bilal profile" /> Book a Call</div></Link>
                    </motion.div>
                </motion.div>
                <div className="col-2 logo-right">
                    <Link to={'https://lunchbox.io/'} target="_blank"><img src={lunchbox} className="lunchbox-logo animate__animated animate__backInDown" alt="lunchbox brand logo" /></Link>
                    <Link to={'https://restaurantcrumbs.com/'} target="_blank"><img src={crumbs} className="crumbs-logo animate__animated animate__backInRight" alt="crumbs brand logo" /></Link> <br/>
                    <Link to={'https://www.chatmeter.com/'} target="_blank"><img src={chatmeter} className="chatmeter-logo animate__animated animate__backInDown" alt="chatmeter brand logo" /></Link>
                    <div className="blur-color-1 rounded-pill"></div>
                    <div className="blur-color-2 rounded-pill"></div>
                </div>
            </div>
            
        </div>
    </div>
    <div className="s2-partner">
        <p className="text-center">Here's who's already in the network</p>
        <motion.div variants={item} whileInView="visible" initial="hidden"  className="logos-pill rounded-pill m-auto shadow">
            <Link to={'https://www.restaurant365.com/'} rel="noreferrer" target="_blank"><img src={R365} alt="R365 brand logo" /></Link>
            <Link to={'https://www.olo.com/'} rel="noreferrer" target="_blank"><img variants={item} whileInView="visible" initial="hidden" src={olo} alt="olo brand logo" /></Link>
            <Link to={'https://restaurantcrumbs.com/'} rel="noreferrer" target="_blank"><img variants={item} whileInView="visible" initial="hidden" src={crumbs} alt="crumbs brand logo" /></Link>
            <Link to={'https://lunchbox.io/'} rel="noreferrer" target="_blank"><img variants={item} whileInView="visible" initial="hidden" src={lunchbox} alt="lunchbox brand logo" /></Link>
            <Link to={'https://www.chatmeter.com/'} rel="noreferrer" target="_blank"><img variants={item} whileInView="visible" initial="hidden" src={chatmeter} alt="chatmeter brand logo" /></Link>
            {/* <Link to={'https://tjtpa.com/'} rel="noreferrer" target="_blank"><img variants={item} whileInView="visible" initial="hidden" src={tjt} alt="TJT brand logo" /></Link> */}
        </motion.div>
    </div>
    {/* (<div className="s2-partner">
         <p className="text-center">Here's who's already in the network</p>
         <Marquee  pauseOnHover="true" className="logos-pill w-100">
             <Link to={'https://www.restaurant365.com/'} rel="noreferrer" target="_blank"><img src={R365} alt="R365 brand logo" /></Link>
            <Link to={'https://www.olo.com/'} rel="noreferrer" target="_blank"><img variants={item} whileInView="visible" initial="hidden" src={olo} alt="olo brand logo" /></Link>
             <Link to={'https://restaurantcrumbs.com/'} rel="noreferrer" target="_blank"><img variants={item} whileInView="visible" initial="hidden" src={crumbs} alt="crumbs brand logo" /></Link>
             <Link to={'https://lunchbox.io/'} rel="noreferrer" target="_blank"><img variants={item} whileInView="visible" initial="hidden" src={lunchbox} alt="lunchbox brand logo" /></Link>
             <Link to={'https://www.chatmeter.com/'} rel="noreferrer" target="_blank"><img variants={item} whileInView="visible" initial="hidden" src={chatmeter} alt="chatmeter brand logo" /></Link>
             <Link to={'https://tjtpa.com/'} rel="noreferrer" target="_blank"><img variants={item} whileInView="visible" initial="hidden" src={tjt} alt="TJT brand logo" /></Link>
         </Marquee>
     </div>) */}
    </>
  )
}

const ShinyText = ({ text, disabled = false, speed = 5, className = '' }) => {
  const animationDuration = `${speed}s`;

  return (
    <div
      className={`shiny-text ${disabled ? 'disabled' : ''} ${className}`}
      style={{ animationDuration }}
    >
      {text}
    </div>
  );
};

export default Section1